const LegacyModalDialogVariantEnum = {
    Standard: 'standard',
    PanelRight: 'panel-right',
    PanelLeft: 'panel-left',
    PanelBottom: 'panel-bottom',
    PanelTop: 'panel-top',
    Menu: 'menu'
};

export { LegacyModalDialogVariantEnum };
